// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 205 ? "ed48eaa7" : chunkId) + "." + {"205":"6d7e8c36e5c51e37","7857":"d9cb16a8de9c0956"}[chunkId] + ".js";
};